const brandsMap = {
  'ua-mlb': 'MARLBORO',
  'ua-bnd': 'BOND STREET',
  'ua-mpm': 'PHILIP MORRIS',
  'ua-lm': 'L&M',
  'ua-ch': 'CHESTERFIELD',
  'ua-prl': 'PARLIAMENT',
  'ua-kv': 'KV'
};

const brandKeys = Object.keys(brandsMap).sort((a, b) => b.length - a.length);

const getBrandName = (brandLink) => {
  if (typeof brandLink !== 'string') return brandLink;

  const lowerCaseBrandLink = brandLink.toLowerCase();
  const foundKey = brandKeys.find((key) =>
    lowerCaseBrandLink.includes(key.toLowerCase())
  );

  if (foundKey) return brandsMap[foundKey];

  return brandLink;
};

export default {
  getBrandName,
  brandKeys
};
